import { expVal } from '@atlassian/jira-feature-experiments';
import {
	ASSIGNEE,
	ISSUE_PARENT,
	ISSUE_TYPE,
	LABEL,
	VERSION,
	CUSTOM_FILTER,
	QUERY_PARAM_ASSIGNEE,
	QUERY_PARAM_ISSUE_PARENT,
	QUERY_PARAM_ISSUE_TYPE,
	QUERY_PARAM_LABEL,
	QUERY_PARAM_TEXT,
	QUERY_PARAM_VERSION,
	QUERY_PARAM_CUSTOM_FILTER,
	TEXT,
	QUERY_PARAM_SEARCH,
	QUERY_PARAM_QUICK_FILTER,
	JQL,
	QUERY_PARAM_JQL,
} from '../../constants.tsx';
import type { Filters, SearchQueryParams } from '../../types.tsx';

const toArray = <T extends string>(x: T | T[]) => (Array.isArray(x) ? x : x.split(','));

export const getFiltersFromQuery = (
	searchParams: SearchQueryParams,
	isVersionsFeatureEnabled: boolean,
	isCompanyManaged: boolean,
): Filters => {
	const filtersFromQuery: Partial<Filters> = {};

	if (!isCompanyManaged && expVal('filter_refinement_in_tmp_backlog', 'isEnabled', false)) {
		if (searchParams[QUERY_PARAM_CUSTOM_FILTER]) {
			filtersFromQuery[CUSTOM_FILTER] = toArray(searchParams[QUERY_PARAM_CUSTOM_FILTER]);
		}
		if (searchParams[QUERY_PARAM_JQL]) {
			filtersFromQuery[JQL] = searchParams[QUERY_PARAM_JQL];
		}
		return filtersFromQuery;
	}

	// search comes from old CMP
	if (searchParams[QUERY_PARAM_SEARCH]) {
		filtersFromQuery[TEXT] = searchParams[QUERY_PARAM_SEARCH];
	}

	if (searchParams[QUERY_PARAM_TEXT]) {
		filtersFromQuery[TEXT] = searchParams[QUERY_PARAM_TEXT];
	}

	if (searchParams[QUERY_PARAM_ASSIGNEE]) {
		filtersFromQuery[ASSIGNEE] = toArray(searchParams[QUERY_PARAM_ASSIGNEE]);
	}

	if (searchParams[QUERY_PARAM_LABEL]) {
		filtersFromQuery[LABEL] = toArray(searchParams[QUERY_PARAM_LABEL]);
	}

	if (searchParams[QUERY_PARAM_ISSUE_PARENT]) {
		filtersFromQuery[ISSUE_PARENT] = toArray(searchParams[QUERY_PARAM_ISSUE_PARENT]);
	}

	if (searchParams[QUERY_PARAM_VERSION] && isVersionsFeatureEnabled) {
		filtersFromQuery[VERSION] = toArray(searchParams[QUERY_PARAM_VERSION]);
	}

	if (searchParams[QUERY_PARAM_ISSUE_TYPE]) {
		filtersFromQuery[ISSUE_TYPE] = toArray(searchParams[QUERY_PARAM_ISSUE_TYPE]);
	}

	// quickFilters from the old CMP
	if (searchParams[QUERY_PARAM_QUICK_FILTER]) {
		filtersFromQuery[CUSTOM_FILTER] = toArray(searchParams[QUERY_PARAM_QUICK_FILTER]);
	}

	if (searchParams[QUERY_PARAM_CUSTOM_FILTER]) {
		filtersFromQuery[CUSTOM_FILTER] = toArray(searchParams[QUERY_PARAM_CUSTOM_FILTER]);
	}

	return filtersFromQuery;
};

export const getQueryFromFilters = (filters: Filters, isCompanyManaged: boolean) => {
	// TMP backlog is using the new filters experience
	if (!isCompanyManaged && expVal('filter_refinement_in_tmp_backlog', 'isEnabled', false)) {
		return {
			[QUERY_PARAM_JQL]: filters[JQL] || undefined,
			[QUERY_PARAM_CUSTOM_FILTER]: filters[CUSTOM_FILTER]
				? filters[CUSTOM_FILTER].join(',')
				: undefined,
		};
	}

	return {
		[QUERY_PARAM_TEXT]: filters[TEXT] || undefined,
		// Replace CMP search with text above
		[QUERY_PARAM_SEARCH]: undefined,

		[QUERY_PARAM_ASSIGNEE]: filters[ASSIGNEE] ? filters[ASSIGNEE].join(',') : undefined,

		[QUERY_PARAM_LABEL]: filters[LABEL] ? filters[LABEL].join(',') : undefined,

		[QUERY_PARAM_ISSUE_PARENT]: filters[ISSUE_PARENT] ? filters[ISSUE_PARENT].join(',') : undefined,

		[QUERY_PARAM_ISSUE_TYPE]: filters[ISSUE_TYPE] ? filters[ISSUE_TYPE].join(',') : undefined,

		[QUERY_PARAM_VERSION]: filters[VERSION] ? filters[VERSION].join(',') : undefined,
		[QUERY_PARAM_CUSTOM_FILTER]: filters[CUSTOM_FILTER]
			? filters[CUSTOM_FILTER].join(',')
			: undefined,
		// Replace CMP quickFilter with customFilter
		[QUERY_PARAM_QUICK_FILTER]: undefined,
	};
};
